export default [
  {
    path: '',
    name: 'company list',
    component: () => import('@/views/app/company/list/page-list.vue'),
    meta: { title: 'Daftar Company' },
  },
]
